import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import './styles.css'

class DeteleTeam extends Component {
  constructor (props) {
    super(props)

    this.dismissPopup = this.dismissPopup.bind(this)
    this.deleteTeam = this.deleteTeam.bind(this)
  }

  dismissPopup () {
    this.props.dispatch(actions.switchDeleteTeam())
  }

  deleteTeam () {
    JSON.stringify(this.props.myTeam) !== '{}' && this.props.dispatch(actions.deleteTeam(this.props.myTeam._id))
  }

  render () {
    return (
      <div className='dashboard-popup-notif'>
        <div className='hey-popup-header'>
          <h4 className='header-text'>DELETING TEAM</h4>
          <button
            onClick={this.dismissPopup}
            className='black-cross'>
            <img alt='' src='/imgs/close.png' />
          </button>
        </div>
        {/* <div className='line'>
          <div className='left'>
            <div> LEAVING HACKATHON</div>
          </div>
          <div className='center' />
          <div className='right' />
        </div>
        <div className='silver-line' /> */}
        {/* <div className='line'>
          <div className='left'>
            <div> From:</div>
            <div> To:</div>
          </div>
          <div className='center'>
            <div>Name Surname <span className='red'>@handle</span>
            </div>
            <div>me</div>
          </div>
          <div className='right'>
            <div className='cell-date'>
              DATE
            </div>
          </div>
        </div> */}
        {/* <div className='silver-line' /> */}
        <div className='pop-message-container '>
          <div className='dashboard-players2'>
            <div className='y-scroll-wrap2'>
              <div className='y-scroll2'>
                <div className='dashboard-players-list2'>
                  <div className='dashboard-players-row2'>
                    <div>
                      <span className='red'>
                        You are about to DELETE your team.
                        Please consider that this action cannot be undone.
                      </span>
                    </div>
                  </div>
                  <div className='dashboard-players-row2 leave-bttn'>
                    <button
                      onClick={this.deleteTeam}
                      className='button'>Delete my team</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    myTeam: state.team.myTeam
  }
}

export default connect(mapStateToProps)(DeteleTeam)



// WEBPACK FOOTER //
// ./src/components/common/popups/DeleteTeam.js